// extracted by mini-css-extract-plugin
module.exports = {"slider":"styles_slider__tyk9p","wrapper":"styles_wrapper__RxSsd","slick":"styles_slick__eltxh","slide":"styles_slide__V7_rk","text":"styles_text__OLhXa"};